import React, { Component } from "react";
// icons
import ReactIconKit from "react-icons-kit";
import Ionicon from "react-ionicons";
// utilities
import {_DefaultIconColor, guessIconset, isIonicons, getReactIconsKitSvg} from "./Iconset.js";
import style from "./style.js";

/**
 * Render an Icon component
 *
 * <Icon iconset={iconset} size={size} />
 * iconset = string (check availableIconsets constant)
 * size = integer (default 60)
 */
class Icon extends Component {
  constructor(props) {
    super(props);
    let iconset = guessIconset(this.props.iconset);
    this.state={iconset:iconset}
    this.size = isIonicons(iconset)? this.props.size + "" : parseInt(this.props.size,10);
    this.color = this.props.color || _DefaultIconColor;
  }

  componentWillReceiveProps(nextProps){
    if(this.props.iconset!=nextProps.iconset){
      let iconset= guessIconset(nextProps.iconset)
      this.setState({iconset:iconset})
    }
  }

  renderReactIconsKit(){
    let icon = getReactIconsKitSvg(this.state.iconset, this.props.icon);
    if(!icon){
      return null
    }
    
    // render icon
    return (
      <ReactIconKit icon={icon} color={this.color} size={this.size} style={style.icon} />
    );
  }

  renderIonic(){
    // console.log("renderIonic", this.props.icon)
    return (
      <Ionicon icon={this.props.icon} color={this.color} fontSize={this.size} style={style.icon} />
    );
  }

  render(){
    return isIonicons(this.state.iconset)? this.renderIonic() : this.renderReactIconsKit();
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/IconPicker/Icon.js